import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const AssessmentsPage = () => {
    const { jobId } = useParams();
    const [jobDetails, setJobDetails] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [assessmentType, setAssessmentType] = useState("");

    // ✅ Fetch Job Details
    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                console.log(`📌 Fetching job details for Job ID: ${jobId}`);
                const response = await axios.get(`http://127.0.0.1:5000/jobs/${jobId}`);

                if (response.data && response.data.title) {
                    setJobDetails(response.data);
                } else {
                    throw new Error("Job details not found.");
                }
            } catch (error) {
                console.error("❌ Error fetching job details:", error);
                setError("Failed to load job details.");
            }
        };

        fetchJobDetails();
    }, [jobId]);

    // ✅ Fetch AI-Generated Assessment Questions
    const fetchAssessmentQuestions = async (type, expectedCount) => {
        if (!jobDetails) {
            alert("❌ Job details not loaded. Please try again.");
            return;
        }

        try {
            setLoading(true);
            setAssessmentType(type);
            setQuestions([]);

            console.log(`🔹 Requesting ${type} assessment for Job ID: ${jobId}`);
            
            const response = await axios.post(`http://127.0.0.1:5000/generate_assessment`, {
                job_id: jobId,
                assessment_type: type
            });

            if (!response.data.assessment_questions || response.data.assessment_questions.length === 0) {
                throw new Error("No assessment questions received.");
            }

            // ✅ Extract valid questions and format correctly
            const formattedQuestions = response.data.assessment_questions
                .map((q, index) => `${index + 1}. ${q.trim()}`)  // ✅ Ensure proper numbering
                .slice(0, expectedCount);  // ✅ Ensure correct question count

            setQuestions(formattedQuestions);
        } catch (error) {
            console.error("❌ Error fetching AI-generated assessment questions:", error);
            setError("Failed to load assessment questions.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
            <h2>Preview Assessments for {jobDetails ? jobDetails.title : `Job ID: ${jobId}`}</h2>
            {error && <p style={{ color: "red" }}>{error}</p>}

            <p>Select an assessment type to preview:</p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button onClick={() => fetchAssessmentQuestions('analytical', 50)} 
                    style={{ padding: '10px 20px', backgroundColor: '#007BFF', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '5px' }}>
                    Preview Analytical Assessment (50 Questions)
                </button>
                <button onClick={() => fetchAssessmentQuestions('behavioral', 30)} 
                    style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '5px' }}>
                    Preview Behavioral Assessment (30 Questions)
                </button>
                <button disabled 
                    style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none', cursor: 'not-allowed', borderRadius: '5px' }}>
                    Preview Simulation and Situational Assessment (In Development)
                </button>
            </div>

            {assessmentType && (
                <>
                    <h3 style={{ marginTop: '20px' }}>{assessmentType.charAt(0).toUpperCase() + assessmentType.slice(1)} Assessment</h3>
                    {loading ? (
                        <p>Loading questions...</p>
                    ) : (
                        <ol>
                            {questions.length > 0 ? (
                                questions.map((question, index) => (
                                    <li key={index} style={{ marginBottom: '10px' }}>{question}</li>
                                ))
                            ) : (
                                <p>No questions available.</p>
                            )}
                        </ol>
                    )}
                </>
            )}
        </div>
    );
};

export default AssessmentsPage;

